exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".three-background{z-index:-5;width:100%;height:100%;position:absolute;top:0;left:0}.background-renderer canvas{position:absolute;top:0;left:0;z-index:-10}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1c7cb3be!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/ThreeBackground/ThreeBackground.vue
// module id = 114
// module chunks = 0